export default __webpack_public_path__ + "static/media/Crystallite.db6506a6.jpg";